export default "__VITE_ASSET__CeZ8q37d__"